var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-bar"},[_c('ul',_vm._l((_vm.stepLength),function(step,index){return _c('li',{key:index,class:_vm.currentStep === step ? 'current' : ''})}))])}
var staticRenderFns = []

export { render, staticRenderFns }